__turbopack_context__.v({
  "form": "page-module__OFtwJW__form",
  "formField": "page-module__OFtwJW__formField",
  "formInput": "page-module__OFtwJW__formInput",
  "frame": "page-module__OFtwJW__frame",
  "image": "page-module__OFtwJW__image",
  "intoTextSuccess": "page-module__OFtwJW__intoTextSuccess",
  "introText": "page-module__OFtwJW__introText",
  "link": "page-module__OFtwJW__link",
  "noCodePageHeader": "page-module__OFtwJW__noCodePageHeader",
  "pageHeader": "page-module__OFtwJW__pageHeader",
  "submit": "page-module__OFtwJW__submit",
});
